<mat-nav-list fxLayout="column" fxFill>
  <ng-container *ngFor="let navItem of mainNavItems">
    <a
      class="num-mat-list-item"
      [routerLinkActive]="'num-mat-list-item--active'"
      mat-list-item
      [routerLink]="navItem.routeTo"
      (click)="menuItemClicked($event, navItem)"
    >
      <fa-icon size="lg" [fixedWidth]="true" [icon]="navItem.icon"></fa-icon>
      <div class="navItem-font" *ngIf="isSideMenuExpanded">
        {{ navItem.translationKey | translate }}
      </div>
    </a>
  </ng-container>

  <span fxFlex></span>
  <div fxLayout="row" fxLayoutAlign="end center" class="num-logo-row">
    <button
      type="button"
      [attr.aria-label]="'APPLAYOUT.TOGGLE.LABEL' | translate"
      mat-icon-button
      (click)="toggleMenu()"
    >
      <fa-icon *ngIf="isSideMenuExpanded" size="1x" icon="angle-double-left"></fa-icon>
      <fa-icon *ngIf="!isSideMenuExpanded" size="1x" icon="angle-double-right"></fa-icon>
    </button>
  </div>
</mat-nav-list>
